import appLogo from '@/assets/images/app_logo.svg';
import appLogoDark from '@/assets/images/app_logo_dark.svg';
import appIcon from '@/assets/images/khronox_icon.svg';
import { useUIStore } from '@/core/stores/ui.store';
import { cn } from '@/core/lib/utils';

type LogoSize = 'sm' | 'md' | 'lg';

interface HeaderLogoProps {
  size?: LogoSize;
}

const LOGO_SIZES: Record<LogoSize, string> = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-10',
};

const ICON_SIZES: Record<LogoSize, string> = {
  sm: 'h-5',
  md: 'h-6',
  lg: 'h-7',
};

export function HeaderLogo({ size = 'lg' }: HeaderLogoProps) {
  const { theme } = useUIStore();
  const isDark =
    theme === 'dark' ||
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

  return (
    <>
      {/* Isotipo — solo en móvil */}
      <img src={appIcon} alt="Khronox" className={cn('block lg:hidden w-auto', ICON_SIZES[size])} />

      {/* Logotipo completo — desktop */}
      <img
        src={isDark ? appLogo : appLogoDark}
        alt="Khronox"
        className={cn('hidden lg:block w-auto', LOGO_SIZES[size])}
      />
    </>
  );
}
